/*فروشگاه و پاساژ*/import * as React from "react"

function SvgComponent(props) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={95.893}
        height={95.893}
        viewBox="0 0 95.893 95.893"
        {...props}
      >
        <path
          data-name="Path 7761"
          d="M35.573 1.547h55.68V88.16h-55.68z"
          fill="#737373"
        />
        <path
          data-name="Path 7762"
          d="M35.573 1.547h51.04V88.16h-51.04z"
          fill="rgba(253,248,248,0.54)"
        />
        <path
          data-name="Path 7763"
          d="M92.799 88.16h-3.093V3.093H37.119v26.294h-3.093V1.547A1.546 1.546 0 0135.573 0h55.68A1.546 1.546 0 0192.8 1.547z"
        />
        <path
          data-name="Path 7764"
          d="M66.506 29.387h9.28V41.76h-9.28z"
          fill="#4f75ad"
        />
        <path
          data-name="Path 7765"
          d="M66.506 29.387h4.64V41.76h-4.64z"
          fill="#699ce6"
        />
        <path
          data-name="Path 7766"
          d="M75.786 29.387h9.28V41.76h-9.28z"
          fill="#4f75ad"
        />
        <path
          data-name="Path 7767"
          d="M75.786 29.387h4.64V41.76h-4.64z"
          fill="#699ce6"
        />
        <path
          data-name="Path 7768"
          d="M75.786 47.946h9.28v12.373h-9.28z"
          fill="#4f75ad"
        />
        <path
          data-name="Path 7769"
          d="M75.786 47.946h4.64v12.373h-4.64z"
          fill="#699ce6"
        />
        <path
          data-name="Path 7770"
          d="M66.506 47.946h9.28v12.373h-9.28z"
          fill="#4f75ad"
        />
        <path
          data-name="Path 7771"
          d="M66.506 47.946h4.64v12.373h-4.64z"
          fill="#699ce6"
        />
        <path
          data-name="Path 7772"
          d="M51.04 47.946h9.28v12.373h-9.28z"
          fill="#4f75ad"
        />
        <path
          data-name="Path 7773"
          d="M51.04 47.946h4.64v12.373h-4.64z"
          fill="#699ce6"
        />
        <path
          data-name="Path 7774"
          d="M51.04 29.387h9.28V41.76h-9.28z"
          fill="#4f75ad"
        />
        <path
          data-name="Path 7775"
          d="M51.04 29.387h4.64V41.76h-4.64z"
          fill="#699ce6"
        />
        <path
          data-name="Path 7776"
          d="M69.599 88.16v-9.28a6.187 6.187 0 00-12.373 0v9.28z"
          fill="#98775a"
        />
        <path
          data-name="Path 7777"
          d="M61.093 73.155a6.18 6.18 0 00-3.867 5.724v9.276h7.733v-9.28a6.18 6.18 0 00-3.866-5.72z"
          fill="#cb9e78"
        />
        <path
          data-name="Path 7778"
          d="M1.547 88.16h92.8v6.187h-92.8z"
          fill="#4c4d4c"
        />
        <path
          data-name="Path 7779"
          d="M1.547 88.16h88.16v6.187H1.547z"
          fill="#656665"
        />
        <path
          data-name="Path 7780"
          d="M4.64 29.387h46.4V88.16H4.64z"
          fill="#737373"
        />
        <path
          data-name="Path 7781"
          d="M4.64 29.387H46.4V88.16H4.64z"
          fill="#999"
        />
        <path
          data-name="Path 7782"
          d="M18.56 72.693h9.28V88.16h-9.28z"
          fill="#98775a"
        />
        <path
          data-name="Path 7783"
          d="M18.56 72.693h4.64V88.16h-4.64z"
          fill="#cb9e78"
        />
        <path
          data-name="Path 7784"
          d="M27.84 72.693h9.28V88.16h-9.28z"
          fill="#98775a"
        />
        <path
          data-name="Path 7785"
          d="M27.84 72.693h4.64V88.16h-4.64z"
          fill="#cb9e78"
        />
        <path
          data-name="Path 7786"
          d="M4.64 35.573h15.467V51.04H4.64z"
          fill="#4f75ad"
        />
        <path
          data-name="Path 7787"
          d="M4.64 35.573h10.827V51.04H4.64z"
          fill="#699ce6"
        />
        <path
          data-name="Path 7788"
          d="M20.107 35.573h15.467V51.04H20.107z"
          fill="#4f75ad"
        />
        <path
          data-name="Path 7789"
          d="M20.107 35.573h10.827V51.04H20.107z"
          fill="#699ce6"
        />
        <path
          data-name="Path 7790"
          d="M35.573 35.573H51.04V51.04H35.573z"
          fill="#4f75ad"
        />
        <path
          data-name="Path 7791"
          d="M35.573 35.573H46.4V51.04H35.573z"
          fill="#699ce6"
        />
        <path
          data-name="Path 7792"
          d="M35.573 51.04H51.04v15.467H35.573z"
          fill="#4f75ad"
        />
        <path
          data-name="Path 7793"
          d="M35.573 51.04H46.4v15.467H35.573z"
          fill="#699ce6"
        />
        <path
          data-name="Path 7794"
          d="M20.107 51.04h15.467v15.467H20.107z"
          fill="#4f75ad"
        />
        <path
          data-name="Path 7795"
          d="M20.107 51.04h10.827v15.467H20.107z"
          fill="#699ce6"
        />
        <path
          data-name="Path 7796"
          d="M4.64 51.04h15.467v15.467H4.64z"
          fill="#4f75ad"
        />
        <path
          data-name="Path 7797"
          d="M4.64 51.04h10.827v15.467H4.64z"
          fill="#699ce6"
        />
        <path
          data-name="Path 7798"
          d="M94.346 95.893H1.547A1.546 1.546 0 010 94.346V88.16a1.546 1.546 0 011.547-1.547h92.8a1.546 1.546 0 011.547 1.547v6.187a1.546 1.546 0 01-1.548 1.546zM3.093 92.8H92.8v-3.094H3.093z"
        />
        <path
          data-name="Path 7799"
          d="M52.586 88.16h-3.093V30.933H6.186V88.16H3.093V29.387A1.546 1.546 0 014.64 27.84h46.4a1.546 1.546 0 011.547 1.547z"
        />
        <path data-name="Path 7800" d="M4.64 49.493h46.4v3.093H4.64z" />
        <path
          data-name="Path 7801"
          d="M37.12 89.706H18.56a1.546 1.546 0 01-1.547-1.547V72.693a1.546 1.546 0 011.547-1.547h18.56a1.546 1.546 0 011.547 1.547v15.466a1.546 1.546 0 01-1.547 1.547zm-17.014-3.093h15.467V74.239H20.106z"
        />
        <path data-name="Path 7802" d="M26.293 72.693h3.093V88.16h-3.093z" />
        <path data-name="Path 7803" d="M51.04 64.96h40.213v3.093H51.04z" />
        <path data-name="Path 7804" d="M4.64 64.96h46.4v3.093H4.64z" />
        <path data-name="Path 7805" d="M18.56 51.04h3.093v15.467H18.56z" />
        <path data-name="Path 7806" d="M34.026 51.04h3.093v15.467h-3.093z" />
        <path data-name="Path 7807" d="M4.64 34.026h46.4v3.093H4.64z" />
        <path data-name="Path 7808" d="M18.56 35.573h3.093V51.04H18.56z" />
        <path data-name="Path 7809" d="M34.026 35.573h3.093V51.04h-3.093z" />
        <path
          data-name="Path 7810"
          d="M52.586 18.559h-3.093v-4.273l-.162.326a1.61 1.61 0 01-2.767 0l-.164-.326v4.275h-3.094V7.733a1.547 1.547 0 012.931-.691l1.709 3.42 1.709-3.42a1.547 1.547 0 012.931.691z"
        />
        <path
          data-name="Path 7811"
          d="M64.96 18.56h-3.093v-7.733a1.547 1.547 0 10-3.093 0v7.733H55.68v-7.733a4.64 4.64 0 019.28 0z"
        />
        <path data-name="Path 7812" d="M57.226 12.373h6.187v3.093h-6.187z" />
        <path
          data-name="Path 7813"
          d="M74.24 18.56H69.6a1.546 1.546 0 01-1.547-1.546V6.187h3.093v9.28h3.093z"
        />
        <path
          data-name="Path 7814"
          d="M83.52 18.56h-4.64a1.546 1.546 0 01-1.547-1.546V6.187h3.093v9.28h3.093z"
        />
        <path data-name="Path 7815" d="M35.573 21.653h55.68v3.093h-55.68z" />
        <path
          data-name="Path 7816"
          d="M85.067 43.307h-18.56a1.546 1.546 0 01-1.547-1.547V29.387a1.546 1.546 0 011.547-1.547h18.56a1.546 1.546 0 011.547 1.547V41.76a1.546 1.546 0 01-1.547 1.547zm-17.014-3.094H83.52v-9.28H68.053z"
        />
        <path
          data-name="Path 7817"
          d="M60.32 43.307h-9.28v-3.094h7.733v-9.28H51.04V27.84h9.28a1.546 1.546 0 011.547 1.547V41.76a1.546 1.546 0 01-1.547 1.547z"
        />
        <path data-name="Path 7818" d="M74.24 29.387h3.093V41.76H74.24z" />
        <path
          data-name="Path 7819"
          d="M85.067 61.867h-18.56a1.546 1.546 0 01-1.547-1.547V47.947a1.546 1.546 0 011.547-1.547h18.56a1.546 1.546 0 011.547 1.547V60.32a1.546 1.546 0 01-1.547 1.547zm-17.014-3.094H83.52v-9.28H68.053z"
        />
        <path
          data-name="Path 7820"
          d="M60.32 61.867h-9.28v-3.094h7.733v-9.28H51.04V46.4h9.28a1.546 1.546 0 011.547 1.547V60.32a1.546 1.546 0 01-1.547 1.547z"
        />
        <path data-name="Path 7821" d="M74.24 47.946h3.093v12.373H74.24z" />
        <path
          data-name="Path 7822"
          d="M71.147 88.159h-3.094v-9.28a4.64 4.64 0 00-9.28 0v9.28H55.68v-9.28a7.733 7.733 0 0115.467 0z"
        />
      </svg>
    )
  }
  
  const MemoSvgComponent = React.memo(SvgComponent)
  export default MemoSvgComponent
  